// Exhibition display policy; account passwords are never needed here.
export function usesDemoAvatars() {
  try {
    return JSON.parse(localStorage.getItem("user") || "{}").id === "69da0f6e1211daf5cab66535";
  } catch {
    return false;
  }
}

export function personImage(url, person = {}) {
  if (!usesDemoAvatars()) return url;
  const age = Number(person.age);
  const group = age >= 46 ? "46-60" : age >= 36 ? "36-45" : age >= 26 ? "26-35" : "19-25";
  return `/${String(person.sex) === "1" ? "M" : "FM"}-${group}.jpg`;
}
